import { Suspense } from "react"
import { BrowserRouter } from "react-router-dom"
import { I18nextProvider, useTranslation } from "react-i18next"
import i18n from "@/i18n"
import { AppRoutes } from "@/app/router"
import LangHtmlSync from "@/app/LangHtmlSync"
import ScrollToTop from "@/app/ScrollToTop"
import { QueryProvider } from "@/app/QueryProvider"
import { AuthProvider } from "@/features/auth/AuthContext"
import { NotificationsProvider } from "@/features/notifications/NotificationsProvider"
import { ToastProvider } from "@/features/toast/ToastProvider"
import { LoadingBlock } from "@/widgets/LoadingBlock"
import { ProductAnalyticsTracker } from "@/app/ProductAnalyticsTracker"

const PageLoader = () => {
  const { t } = useTranslation()
  return <LoadingBlock variant="page" message={t("common.loading")} />
}

export default function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <LangHtmlSync />
      <ToastProvider>
        <QueryProvider>
          <AuthProvider>
            <BrowserRouter basename={__BASE_PATH__}>
              <ProductAnalyticsTracker />
              <NotificationsProvider>
                <ScrollToTop />
                <Suspense fallback={<PageLoader />}>
                  <AppRoutes />
                </Suspense>
              </NotificationsProvider>
            </BrowserRouter>
          </AuthProvider>
        </QueryProvider>
      </ToastProvider>
    </I18nextProvider>
  )
}
